"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m5.2497 8.0687 2.83-2.8268 14.1342 14.15-2.83 2.8269zm4.2361-4.2415 2.828-2.8288 5.6577 5.656-2.828 2.8288zM.999 12.3147l2.8284-2.8284 5.6569 5.6568-2.8285 2.8285zM1 21h12v2H1z"
}), 'Gavel');